<template>
  <div class="sharer sharer-simple">
    <SharerBase class="sharer__list _list" v-bind="$props" />
  </div>
</template>

<script>
import SharerPropsMixin from "../mixins/SharerPropsMixin";
import SharerBase from "./SharerBase";

export default {
  mixins: [SharerPropsMixin],
  components: {
    SharerBase
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
$block: ".sharer";
.sharer-simple {
  #{$block}__list {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  #{$block}__item {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 8px;
    -webkit-tap-highlight-color: transparent;
    &.-tg {
      ._icon {
        width: 85%;
      }
    }
    &.-fb {
      ._icon {
        width: 95%;
      }
    }
    &.-ok {
      ._icon {
        width: 90%;
      }
    }
  }
  #{$block}__icon {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  &[buttons] {
    #{$block}__item {
      width: 44px;
      height: 44px;
      margin: 5px;
      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
      }
      &.-vk {
        ._icon {
          width: 50%;
        }
      }
      &.-fb {
        ._icon {
          width: 48%;
        }
      }
      &.-ok {
        ._icon {
          width: 47%;
        }
      }
      &.-tw {
        ._icon {
          width: 48%;
          svg {
            transform: translateX(1px);
          }
        }
      }
      &.-tg {
        ._icon {
          width: 43%;
          svg {
            transform: translateX(-1px);
          }
        }
      }
    }
  }
  &[buttons][circles] {
    #{$block}__item {
      border-radius: 50%;
      &:before {
        border-radius: 50%;
      }
    }
  }
  &[buttons][colored] {
    #{$block}__item {
      &.-vk {
        &:before {
          background-color: $color_vk;
        }
      }
      &.-fb {
        &:before {
          background-color: $color_fb;
        }
      }
      &.-ok {
        &:before {
          background-color: $color_ok;
        }
      }
      &.-tw {
        &:before {
          background-color: $color_tw;
        }
      }
      &.-tg {
        &:before {
          background-color: $color_tg;
        }
      }
    }
  }
  &[vertical] {
    #{$block}__list {
      flex-direction: column;
    }
  }
  &[hoverScale] {
    #{$block}__item {
      &:before {
        transform: translate3d(0, 0, 0);
        transition: all 0.25s 0s ease;
      }
      &:hover:before {
        transform: scale(1.1);
      }
    }
  }
  &[hoverScaleIcon] {
    #{$block}__item {
      ._icon {
        will-change: transform;
        transition: all 0.1s 0s ease;
      }
      &:hover ._icon {
        transform: scale(1.25);
      }
    }
  }
}
</style>
